export const headers = {
  _id: {
    name: "Orders",
    width: 1,
    color: "#2793de",
  },
};

export const mdHeaders = {
  _id: {
    name: "Orders",
    width: 1,
    color: "#2793de",
  },
};

export const smHeaders = {
  _id: {
    name: "Orders",
    width: 1,
    color: "#2793de",
  },
};

export const hubspotCompanyHeaders = {
  id: {
    name: "Id",
    width: 0.4,
  },
  name: {
    name: "Name",
    width: 0.4,
  },
  industry: {
    name: "Industry",
    width: 0.6,
  },
  domain: {
    name: "Domain",
    width: 0.4,
  },
  archived: {
    name: "Archived",
    width: 0.2,
  },
  createdAt: {
    name: "Date Created",
    width: 0.3,
  },
  updatedAt: {
    name: "Date Updated",
    width: 0.3,
  },
  actions: {
    name: "Actions",
    width: 0.4,
    textAlign: "center",
    justifyContent: "center",
  },
};

export const mdHubspotCompanyHeaders = {
  id: {
    name: "Id",
    width: 0.4,
  },
  name: {
    name: "Name",
    width: 0.4,
  },
  industry: {
    name: "Industry",
    width: 0.6,
  },
  domain: {
    name: "Domain",
    width: 0.4,
  },
  createdAt: {
    name: "Date Created",
    width: 0.3,
  },
  actions: {
    name: "Actions",
    width: 0.4,
    textAlign: "center",
    justifyContent: "center",
  },
};

export const smHubspotCompanyHeaders = {
  id: {
    name: "Id",
    width: 0.4,
  },
  name: {
    name: "Name",
    width: 0.4,
  },
  industry: {
    name: "Industry",
    width: 0.6,
  },
  actions_sm: {
    name: "Actions",
    width: 0.4,
    textAlign: "center",
    justifyContent: "center",
  },
};
